import axios from 'axios';
import has from 'lodash/has.js';

const tokens = {};

const cancelSource = mutation => {
    if (has(tokens, mutation.type) && tokens[mutation.type]) {
        tokens[mutation.type].cancel();
    }

    const source = axios.CancelToken.source();
    tokens[mutation.type] = source;

    return {
        source,
        axiosConfig: {
            cancelToken: source.token,
        },
    };
};

export const errorHandler = mutation => {
    return (error, store) => {
        if (axios.isCancel(error)) {
            // Request canceled, do nothing
        } else {
            console.error('There was a problem: ', error);

            // Handle error
            if (store) {
                store.dispatch('AutoSave/setError', {
                    indicator: mutation,
                    error,
                });
            }
        }
    };
};

export default cancelSource;
